import { Injectable } from '@angular/core';
import { FileDescriptor } from '../../models/file-descriptor';
import { Observable, catchError, of, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseApiService } from './base-api-service.service';
import { Logger } from '../logger.service';

const log = new Logger('OAuthServerErrorHandler');

@Injectable({
  providedIn: 'root'
})
export class BinaryService extends BaseApiService {

  uploadBinary(formId: string, file: File): Observable<FileDescriptor|null> {
    if (formId == null || formId.trim() === '') throw throwError(() => new Error("Argument 'formId' is null or empty"));
    if (!file) throw throwError(() => new Error("Argument 'file' is null or undefined"));

    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<FileDescriptor>(`${environment.apiBaseUrl}/binary/${formId}`, formData).pipe(
      catchError(error => {
        log.warn(`Error uploading binary`);
        return of(null);
      })
    )
  }
}
